export default "__VITE_ASSET__8f1d760c__"